export default{
  services: (state) => state.services,
  service: (state) => state.service
}



// WEBPACK FOOTER //
// ./src/components/service/store/getters.js